import { GithubOutlined } from "@ant-design/icons";
import { DefaultFooter } from "@ant-design/pro-components";
import React from "react";

const Footer: React.FC = () => {
    return null;
    return (
        <DefaultFooter
            style={{
                background: "none",
            }}
            copyright="Powered by Ant Desgin"
            links={[
                {
                    key: "OCR",
                    title: "OCR",
                    href: "https://pro.ant.design",
                    blankTarget: true,
                },
                {
                    key: "github",
                    title: <GithubOutlined />,
                    href: "https://github.com/ant-design/ant-design-pro",
                    blankTarget: true,
                },
                {
                    key: "Ant Design",
                    title: "Ant Design",
                    href: "https://ant.design",
                    blankTarget: true,
                },
            ]}
        />
    );
};

export default Footer;
